<script lang="ts">
  const features = [
    {
      iconSrc: 'assets/icon-2.svg',
      desc: 'Doradzamy klientom'
    },
    {
      iconSrc: 'assets/icon-1.svg',
      desc: 'Sprzedajemy artykuły wysokiej jakości'
    },
    {
      iconSrc: 'assets/icon-3.svg',
      desc: 'Bezpłatnie robimy projekt, aby maksymalnie wykorzystać powierzchnię lady chłodniczej'
    },
    {
      iconSrc: 'assets/icon-4.svg',
      desc: 'Przy dużych projektach pomagamy w ułożeniu pojemników i podestów w ladzie chłodniczej'
    }
  ]
</script> 
<section class="why px-8">
  <h2 class="text-xl mt-16">
    Dlaczego warto zamówić pojemniki w naszej firmie?
</h2>
  <div class="mt-10 grid md:grid-cols-2 gap-x-4 gap-y-10">
    {#each features as { iconSrc, desc} }
      <div class="flex items-center">
        <img src={iconSrc} alt="" class="w-14">
        <p class="ml-6">
          {desc}
        </p>
      </div>
    {/each}
  </div>
</section>